/**
 * Onboarding API — B-2026-0078
 *
 * Thin wrapper over GET /api/users/me/onboarding-status.
 * All fields are computed server-side from channel_members + evaluations_index.
 */

import { apiClient } from './api';

export interface OnboardingStatus {
  has_joined_channel: boolean;
  /** Derived: true when the user has at least one evaluation on record. */
  has_selected_template: boolean;
  has_submitted_eval: boolean;
  first_eval_id: string | null;
  onboarding_complete: boolean;
}

/**
 * Fetch the current user's onboarding checklist state.
 *
 * Designed to be <100 ms on the backend — safe to call on dashboard mount.
 */
export async function getOnboardingStatus(): Promise<OnboardingStatus> {
  const response = await apiClient.get<OnboardingStatus>('/users/me/onboarding-status');
  return response.data;
}
